import React, { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router"
import SideBar from "../../../common/layout/sidebar.component"
import { updateProductAction, deleteProductAction, fetchProductAction } from "../../../state/product/ProductActions"
import { getAction } from "../../../state/actionlog/actionLogSelector"
import BundleForm from "../forms/BundleForm"
import { injectIntl } from "react-intl"
import { ACTION_SUCCESS } from "../../../state/actionlog/ActionLog"
import { BundleFormAttributes, EditBundleProps } from "../../../common/types/bundle"
import { PRODUCT_BUNDLE_ACTION_ID } from "../../../utils/bundle/constants"

const UpdateBundleComponent = (props: EditBundleProps) => {
    const dispatch = useDispatch()
    const bundleIdMatch = props.match.params.bundleId
    const [actionUpdateId, setActionUpdateId] = useState(`${PRODUCT_BUNDLE_ACTION_ID.UPDATE}-${bundleIdMatch}-${Date.now()}`)
    const [actionDeleteId, setActionDeleteId] = useState(`${PRODUCT_BUNDLE_ACTION_ID.DELETE}-${bundleIdMatch}-${Date.now()}`)

    const actionUpdate = useSelector(state => getAction(state, actionUpdateId))
    const actionDelete = useSelector(state => getAction(state, actionDeleteId))
    
    useEffect(() => {
        SideBar.activateMenu("product")
        dispatch(fetchProductAction(`${PRODUCT_BUNDLE_ACTION_ID.GET}-${bundleIdMatch}`, bundleIdMatch))
    }, [])

    const update = (form: BundleFormAttributes) => {
        const updateId=`${PRODUCT_BUNDLE_ACTION_ID.UPDATE}-${bundleIdMatch}-${Date.now()}`
        setActionUpdateId(updateId)
        dispatch(updateProductAction(updateId, bundleIdMatch, form))
    }

    const deleteBundle = () => {
        const deleteId = `${PRODUCT_BUNDLE_ACTION_ID.DELETE}-${bundleIdMatch}-${Date.now()}`
        setActionDeleteId(deleteId)
        dispatch(deleteProductAction(deleteId, bundleIdMatch))
    }
  
    if ((actionUpdate && actionUpdate.status == ACTION_SUCCESS) ||
        (actionDelete && actionDelete.status == ACTION_SUCCESS)) {
        return <Redirect to="/bundles" />
    }
    
    return (
        <>
            <BundleForm
                upsertCallback={update}
                deleteCallback={deleteBundle}
                error={actionUpdate.error || actionDelete.error}
            />
        </>
    )
}

export default injectIntl(UpdateBundleComponent)


// WEBPACK FOOTER //
// ./src/product/bundle/components/EditBundleComponent.tsx